import { api } from '@/fsd/shared/api';
import { IPayment } from '../../model/types/IPayment';

export const getPayments = async (): Promise<IPayment[]> => {
  try {
    const data = await api.get<IPayment[]>('/api/v1/payment/');

    return data;
  } catch (e) {
    console.error('Ошибка при получении оплат:', e);
    return [];
  }
};
